import React, {FunctionComponent, useContext} from 'react';
import './ContractSection.scss'
import {Invoice} from '../../models/invoice.model';
import {InvoiceContext} from '../../context/InvoiceContext';
import {SignatureSignIn} from '../../components/SignatureSignIn/SignatureSignIn';
import {SignatureReject} from '../../components/SignatureReject/SignatureReject';
import {ContractContent} from '../../components/ContractContent/ContractContent';

export const ContractSection: FunctionComponent = () => {
    const invoice: Invoice = useContext(InvoiceContext);

    return (
        <section className='basic-section contract-section'>
            <h3>Contract</h3>

            <ContractContent/>

            {invoice.is_signature_available
                ? <div className='contract-buttons'>
                    <SignatureReject/>
                    <SignatureSignIn/>
                </div>
                : null}
        </section>
    );
};
